import SmoothScroll from 'smooth-scroll';

export default(() => {
    const scroll = new SmoothScroll('a[href^="#"]', {
        topOnEmptyHash: false,
        updateURL: false
    });

    const scrollAnchor = document.querySelector('.js-scroll-anchor');
    if (scrollAnchor) {
        setTimeout(() => {
            scroll.animateScroll(scrollAnchor);
        }, 2000);
    }

    // Redactor smooth scroll setup
    const links = Array.from(document.querySelectorAll('.wysiwyg a[href^="#"]'));
    const linkTargets = Array.from(document.querySelectorAll('.js-scroll-target'));

    const htmlToId = (htmlNode) => `#${htmlNode.innerHTML.toLowerCase().replace(/ /g, '-')}`;

    const scrollOnClick = (link) => {
        const targetFound = linkTargets.find(target => htmlToId(target) === link.getAttribute('href'));
        if (targetFound) scroll.animateScroll(targetFound);
    }

    // Redactor scroll on # link clicks
    links.forEach(link => link.addEventListener('click', () => scrollOnClick(link)));

    // Redactor scroll to section if # matched in URL
    const scrollOnPageLoad = linkTargets.find((target) => {
        return document.location.href.includes(htmlToId(target));
    })
    if (scrollOnPageLoad) setTimeout(() => scroll.animateScroll(scrollOnPageLoad), 1000);

})();
